import { AppointmentID } from "./Appointment";
import { UserID } from "./User";

export interface LoginQRCode {
  token: string;
  user_id: UserID | null;
  appointment_id: AppointmentID | null;
  expire_at: string;
}
